import { QUESTIONNAIRE_CODE } from 'lib/constants';
import { RiskEngineName } from 'types/risk';

export const getQuestionInfo = (engineName: RiskEngineName) => {
  let questionTitle: Partial<Record<QUESTIONNAIRE_CODE, string>> = {
    [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: 'Describe your fitness level',
    [QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION]: 'Consumption of Alcohol',
    [QUESTIONNAIRE_CODE.SMOKING]: 'Describe your smoking habits',
    [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]:
      'Describe your family medical conditions',
  };
  if (engineName === 'diabetes_risk') {
    questionTitle = {
      [QUESTIONNAIRE_CODE.BODY_TYPE]: 'Describe your body complexion',
      [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: 'Describe your fitness level',
      [QUESTIONNAIRE_CODE.EATING_HABITS]: 'Describe your eating habits',
      [QUESTIONNAIRE_CODE.MEDICAL_CONDITIONS]:
        'Describe your medical conditions',
      [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]:
        'Describe your family medical conditions',
    };
  }

  let questionNumber: Partial<Record<QUESTIONNAIRE_CODE, number>> = {
    [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: 1,
    [QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION]: 2,
    [QUESTIONNAIRE_CODE.SMOKING]: 3,
    [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]: 4,
  };
  if (engineName === 'diabetes_risk') {
    questionNumber = {
      [QUESTIONNAIRE_CODE.BODY_TYPE]: 1,
      [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: 2,
      [QUESTIONNAIRE_CODE.EATING_HABITS]: 3,
      [QUESTIONNAIRE_CODE.MEDICAL_CONDITIONS]: 4,
      [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]: 5,
    };
  }

  let sideQuestions: Partial<
    Record<QUESTIONNAIRE_CODE, { label: string; sequence: number }>
  > = {
    [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: {
      label: 'Fitness Level',
      sequence: questionNumber[QUESTIONNAIRE_CODE.FITNESS_LEVEL] ?? 0,
    },
    [QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION]: {
      label: 'Alcohol Consumption',
      sequence: questionNumber[QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION] ?? 0,
    },
    [QUESTIONNAIRE_CODE.SMOKING]: {
      label: 'Smoking Habit',
      sequence: questionNumber[QUESTIONNAIRE_CODE.SMOKING] ?? 0,
    },
    [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]: {
      label: 'Family Medical Conditions',
      sequence:
        questionNumber[QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS] ?? 0,
    },
  };
  if (engineName === 'diabetes_risk') {
    sideQuestions = {
      [QUESTIONNAIRE_CODE.BODY_TYPE]: {
        label: 'Body Complexion',
        sequence: 1,
      },
      [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: {
        label: 'Fitness Level',
        sequence: 2,
      },
      [QUESTIONNAIRE_CODE.EATING_HABITS]: {
        label: 'Eating Habits',
        sequence: 3,
      },
      [QUESTIONNAIRE_CODE.MEDICAL_CONDITIONS]: {
        label: 'Medical Conditions',
        sequence: 4,
      },
      [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]: {
        label: 'Family Medical Conditions',
        sequence: 5,
      },
    };
  }

  return {
    questionTitle,
    questionNumber,
    sideQuestions,
    questionCount: engineName === 'diabetes_risk' ? 5 : 4,
  };
};

// export const questionTitle: Partial<Record<QUESTIONNAIRE_CODE, string>> = {
//   [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: 'Describe your fitness level',
//   [QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION]: 'Consumption of Alcohol',
//   [QUESTIONNAIRE_CODE.SMOKING]: 'Describe your smoking habits',
//   [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]:
//     'Describe your family medical conditions',
// };

// export const questionNumber: Partial<Record<QUESTIONNAIRE_CODE, number>> = {
//   [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: 1,
//   [QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION]: 2,
//   [QUESTIONNAIRE_CODE.SMOKING]: 3,
//   [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]: 4,
// };

// export const sideQuestions: Partial<
//   Record<QUESTIONNAIRE_CODE, { label: string; sequence: number }>
// > = {
//   [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: {
//     label: 'Fitness Level',
//     sequence: questionNumber[QUESTIONNAIRE_CODE.FITNESS_LEVEL] ?? 0,
//   },
//   [QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION]: {
//     label: 'Alcohol Consumption',
//     sequence: questionNumber[QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION] ?? 0,
//   },
//   [QUESTIONNAIRE_CODE.SMOKING]: {
//     label: 'Smoking Habit',
//     sequence: questionNumber[QUESTIONNAIRE_CODE.SMOKING] ?? 0,
//   },
//   [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]: {
//     label: 'Family Medical Conditions',
//     sequence: questionNumber[QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS] ?? 0,
//   },
// };
